// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAJ3ILCl8QQpSP4O5aI-_NPw0hUmLBjpRA",
    authDomain: "timple-firebase-auth-47c10.firebaseapp.com",
    projectId: "timple-firebase-auth-47c10",
    storageBucket: "timple-firebase-auth-47c10.appspot.com",
    messagingSenderId: "687570758484",
    appId: "1:687570758484:web:089c43741fcb32f62eb6c1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;